const nodeEnv = process.env.NODE_ENV || 'dev';
import AppConfig from '../domain/AppConfig';
import AppConfigService from './AppConfigService';

let appConfig:AppConfig = AppConfigService.appConfig();

export default class AppService {

  static serverHost() {
    let origin = AppConfigService.getOrigin();
    if (origin == '//localhost:9021' || origin == '//localhost:3000') {
      return '//localhost:9020';
    }
    if (origin.includes('.local.') || origin.includes('localhost') ) {
      if( AppConfigService.isSsl() ){
        return 'https://web.local.aperza.com:9020';
      }
      return 'http://web.local.aperza.com:9020';
    }

    let appConfig = this.appConfig();

    return `https://web${appConfig.baseComDomain}`;
  }

  static isDevelopment() {
    return nodeEnv === 'dev';
  }

  static isErrorPage() {
    let pathName = window.location.pathname;
    return pathName.indexOf('error') > -1;
  }

  static isMainPage() {
    let pathName = window.location.pathname;
    return pathName === '/' ||
      pathName === '/en' ||
      pathName === '/en/' ||
      pathName.startsWith('/en/?') ||
    pathName === '/ja' ||
    pathName === '/ja/' ||
    pathName.startsWith('/ja/?')
      ;
  }

  static staticUrl(path) {
    let host = appConfig.cdnHost;
    return `${host}${path}`;
  }

  static encodedPath() {
    let encodedPath = "";

    //https://aperza.atlassian.net/browse/AB-5120
    //Exception for order
    if (appConfig.serviceType == 'aperza-order') {
      return encodedPath;
    }

    let path = (location.pathname + location.search).replace(/^\/+/, "");
    if( path !== "/" ){
      encodedPath = encodeURIComponent(path);
    }
    return encodedPath;
  }

  static encodedPathParameter() {
    return `&path=${this.encodedPath()}`
  }

  static appConfig(): AppConfig {
    return appConfig;
  }

}
